import { useMemo } from 'react';
import { gql, useQuery } from 'urql';

export const GET_ORGANIZER_OTP_QUERY = gql`
  query GetOrganizerOtp($eventId: Int!, $userId: Int!) {
    getOrganizerOtp(input: { eventId: $eventId, userId: $userId }) {
      code
      expiresAt
    }
  }
`;

export interface IOrganizerOtpResponse {
  getOrganizerOtp: {
    code: string;
    expiresAt: string;
  };
}

export const useFetchOrganizerOtp = (input: { eventId: number; userId: number } | null) => {
  const variables = useMemo(
    () => (input ? { eventId: input.eventId, userId: input.userId } : undefined),
    [input?.eventId, input?.userId]
  );

  const [result, reexecuteQuery] = useQuery<IOrganizerOtpResponse>({
    query: GET_ORGANIZER_OTP_QUERY,
    variables,
    pause: !variables,
    requestPolicy: 'network-only',
  });

  return { ...result, reexecuteQuery };
};
